import { useEffect, useState } from "react";

export interface OverviewStatistics {
    currentlyTested: number | null;
    reviewsCount: number | null;
    testsCount: number | null;
    averageRating: number | null;
}

const overviewStatisticsDefaultValue = {
    currentlyTested: 3,
    reviewsCount: 293,
    averageRating: 4.7,
    testsCount: 97,
};

export const useOverviewStatistics = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<OverviewStatistics>(overviewStatisticsDefaultValue);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    return {
        ...data,
        isLoading,
    };
};

export interface PopularityMeasuring {
    fiveStarts: number | null;
    fourStars: number | null;
    threeStars: number | null;
    twoStars: number | null;
    oneStars: number | null;
}

const popularityMeasuringDefaultValue = {
    fiveStarts: 11,
    fourStars: 6,
    threeStars: 2,
    twoStars: 2,
    oneStars: 4,
};

export const usePopularityMeasuring = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState<PopularityMeasuring>(popularityMeasuringDefaultValue);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    });

    return {
        ...data,
        isLoading,
    };
};
